import Vue from 'vue'
import App from './App.vue'
import 'iview/dist/styles/iview.css'
import router from './router'
import store from './store'
import iView from 'iview'
// import './assets/css/base.less'
import './assets/css/base.less'

// import $ from 'jquery'

import '../my-theme/dist/iview.css'

Vue.use(iView);

Vue.config.productionTip = false

Vue.prototype.$Message.config({
  duration: 5
});

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import { CHANGE_ROUTE_INFO } from './store/mutation-types'
router.beforeEach((to, from, next) => {
  // if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === 'path') {//path:不兼容组件所在路由
  //   console.log('组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看，浏览器不兼容通知')
  // } else {
  //   next();
  // }
  /* 路由发生变化修改页面title */
  localStorage.setItem('fromPath', from.fullPath)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  store.commit(CHANGE_ROUTE_INFO, to.meta.routeInfo);
  window.scrollTo(0, 0);
  next();
});
// 设置网页标题
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
